<section class="header-interno">
    <div class="container">
        <h1 class="header-interno__title">
            {{title}}
        </h1>
    </div>
</section>